import * as requestFromServer from "./Crud";
import {SelectComponentsSlice, callTypes} from "./Slice";
import { NotificationManager } from "react-notifications";

const {actions} = SelectComponentsSlice;

export const getSearchList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getSaasGameList(queryParams)
    .then(response => {
      const entities = response.data;      
      const source = queryParams.source;
      console.log('state::11', entities, source)
      dispatch(actions.searchListFetched({ entities, source }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getH5GamesSearchList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getH5GamesList(queryParams)
    .then(response => {
      const entities = response.list;      
      const source = queryParams.source;
      console.log('state::11', entities, source)
      dispatch(actions.searchListFetched({ entities, source }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const getGameList = queryParams => dispatch => {
  console.log("actions:getGameList",actions.startCall())
  console.log("queryparams",queryParams)
  dispatch(actions.startCall({ callType: callTypes.list }));
  let req_country = [];
  if(queryParams?.filter?.search?.countries)
  {
    if (queryParams?.filter?.search?.countries.length > 0) {
      for (let i = 0; i < queryParams.filter.search.countries.length; i++) {
        req_country.push(queryParams.filter.search.countries[i].value)
      }
    }
  }

  queryParams.filter.search.countries = req_country;

  return requestFromServer
    .getSaasGameList(queryParams)
    .then(response => {
      const entities = response.data;      
      const source = queryParams.source;

      dispatch(actions.searchListFetched({ entities, source }));
    })
    .catch(error => {
      console.log("error",error)
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const getGameTypeList = queryParams => dispatch => {
 // console.log("queryparams",queryParams)
  console.log("actions:getGameTypeList",actions.startCall())
  dispatch(actions.startCall({ callType: callTypes.list }));
  let req_country = [];
  if(queryParams?.filter?.search?.countries)
  {
    if (queryParams?.filter?.search?.countries.length > 0) {
      for (let i = 0; i < queryParams.filter.search.countries.length; i++) {
        req_country.push(queryParams.filter.search.countries[i].value)
      }
    }
  }
  const companydata = JSON.parse(localStorage.getItem("company"));
  console.log("companydata",companydata)
  let req_company = [];
  if(!queryParams?.filter?.search?.company)
  { req_company.push(companydata._id)
    queryParams.filter.search.company=req_company
  }

  queryParams.filter.search.countries = req_country;
console.log("33333333queryParams",queryParams)
  return requestFromServer
    .getGameTypeList(queryParams)
    .then(response => {
      
    let finalArray = response?.data[0]?.assignGameTypes?.reduce((unique, o) => {
        if(!unique.some(obj => obj._id === o._id)) {
          unique.push(o);
        }
        return unique;
    },[]);
      const entities = finalArray;      
      const gameData = response.data;      
      const source = queryParams.source;

      dispatch(actions.searchGameTypeListFetched({ entities, source, gameData }));
    })
    .catch(error => {
      console.log("error",error)
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const saveCompany = company => dispatch => {
  dispatch(actions.saveCompany(company));
}
